import React, { memo, useCallback, useState } from 'react';
import classnames from 'classnames';
import styles from './ImgVideo.module.less';
import Swiper from 'react-id-swiper';
import 'swiper/css/swiper.css';

export default memo(({ soft, styleInfo }) => {
  const params = {
    centeredSlides: true,
    slidesPerView: '1',
    spaceBetween: 0,
    speed: 300,
    loop: true,
    effect: 'fade',
    autoplay: {
      delay: 1700,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
  };
  return (
    <div className={styles.imgs_video} style={{ ...styleInfo }}>
      {soft?.resUrl && (
        <div className={`video_box`}>
          <img className={`video`} src={soft?.resUrl} />
        </div>
      )}
      {!soft?.resUrl && soft?.captureFileList && soft?.captureFileList?.length > 0 && (
        <div className={`imgs`}>
          <Swiper {...params}>
            {soft?.captureFileList?.map((item, i) => (
              <img className={`imgs_item`} src={item} key={i} style={{ ...styleInfo }} />
            ))}
          </Swiper>
        </div>
      )}
      {!soft?.resUrl &&
        !(soft?.captureFileList && soft?.captureFileList?.length > 0) &&
        soft?.ztImg && <img className={`video`} src={soft?.ztImg} />}
    </div>
  );
});
